













































import { Component, Prop, Vue } from 'vue-property-decorator';
import LoginForm from '@/components/auth/LoginForm.vue';
import { routerModule, authModule } from '../store';
import { RouteData } from '@/api/Wordpress';

@Component({
  components: {
    LoginForm,
  },
})
export default class extends Vue {
  loading: boolean = false;
  page: RouteData | null = null;

  get title() {
    if (!this.page) {
      return;
    }
    return this.page.title.rendered;
  }

  get pageTitle() {
    if (this.acf && this.acf.page_title) {
      return this.acf.page_title.replace(/\*(.*?)\*/g, '<em>$1</em>');
    } else if (this.title) {
      return this.title;
    }
  }

  get acf() {
    if (!this.page) {
      return;
    }
    return this.page.acf;
  }

  sectionLink(link: string) {
    const url = new URL(link);
    if (window.location.hostname === url.hostname) {
      this.$router.push(url.pathname);
    } else {
      window.location.href = link;
    }
  }

  async mounted() {
    try {
      this.loading = true;

      if (this.$route.path === '/') {
        this.page = await routerModule.getHome();
      } else {
        this.page = await routerModule.getPage(this.$route.path);

        if (this.title) {
          const title = this.title + ' - Gowans Auctions';
          const titleElement = document.getElementsByTagName('title')[0];
          if (titleElement) {
            titleElement.innerHTML = title;
          } else {
            document.title = title;
          }

          authModule.trackPageview({
            gtag: this.$gtag,
            route: this.$route,
            pageTitle: decodeURI(this.title),
          });
        }
      }
    } catch (e) {
      // Error
    } finally {
      this.loading = false;
    }
  }
}
